import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import _ from "lodash";
import { useEffect, useState } from "react";
import TextInput from "../TextInput";
import MetricInput from "../MetricInput";
import Button from "../Button";

interface Props {
  item: any;
  value: any;
  handleFormItem: any;
}

export default function TypologiesInput(props: Props) {
  const { value, item, handleFormItem } = props;

  const [renderFields, setRenderFields] = useState<any>([]);
  const [typologyFields, setTypologyFields] = useState<any>(value || []);

  useEffect(() => {
    const newRenderFields = Array.from(
      { length: typologyFields.length },
      () => item
    );

    setRenderFields(newRenderFields);
  }, []);

  const handleAddNewProduct = () => {
    if (!renderFields.length) {
      setRenderFields([item]);
      return;
    }

    setRenderFields((prev: any) => [...prev, _.cloneDeep(item)]);
  };

  const handleDeleteProduct = (indexToRemove: any) => {
    const modifiedRender = [...renderFields];
    modifiedRender.splice(indexToRemove, 1);
    setRenderFields(modifiedRender);

    const modifiedValues = [...typologyFields];
    modifiedValues.splice(indexToRemove, 1);
    setTypologyFields(modifiedValues);

    handleFormItem(modifiedValues, item.chave);
  };

  const handleProductItem = (productItem: any, type: any, index: number) => {
    const currentProduct = typologyFields[index] || {};
    currentProduct[type] = productItem;

    const modifiedArray = [...typologyFields];
    modifiedArray[index] = currentProduct;
    setTypologyFields(modifiedArray);

    handleFormItem(modifiedArray, item.chave);
  };

  return (
    <>
      {!!renderFields?.length &&
        renderFields?.map((item: any, index: number) => {
          if (item === undefined) return null;

          const chave = item.chave;
          const tipologyLength = value?.[index]?.tipologyLength;
          const quantity = value?.[index]?.quantity;
          const total =
            parseFloat(tipologyLength?.value) * parseFloat(quantity);

          return (
            <div
              className="flex flex-col gap-3 rounded-2xl border border-border bg-white p-5 shadow-sm"
              key={index + chave}
            >
              <div className="flex w-full justify-between">
                <p className="text-primary font-semibold">Tipologia</p>
                <IconButton
                  aria-label={`Remover tipologia ${index + 1}`}
                  onClick={() => handleDeleteProduct(index)}
                >
                  <Delete htmlColor="#D00539" />
                </IconButton>
              </div>

              <TextInput
                placeholder={"Material"}
                onChange={(e: any) =>
                  handleProductItem(e.target.value, "material", index)
                }
                variant="outlined"
                value={value?.[index]?.material ?? ""}
              />

              <MetricInput
                id={"tipologyLength"}
                options={["cm"]}
                value={value?.[index]?.tipologyLength ?? { metric: 'cm' }}
                index={index}
                handleFormItem={handleProductItem}
              />

              <TextInput
                placeholder={"Quantidade"}
                onChange={(e) =>
                  handleProductItem(
                    e.target.value.replace(/[^0-9]+/g, ""),
                    "quantity",
                    index
                  )
                }
                variant="outlined"
                value={value?.[index]?.quantity}
              />

              <p className="text-primary font-semibold">Total da tipologia {index + 1}</p>
              <p className="font-medium text-muted">
                {!isNaN(total) ? parseFloat(total.toFixed(2)) : 0}
              </p>
            </div>
          );
        })}

      <Button
        className="!border font-medium"
        variant="outlined"
        onClick={handleAddNewProduct}
      >
        Adicionar tipologia
      </Button>
    </>
  );
}
